/** The search runs from this many characters of the trimmed query (use-search-player-teams) */
export const MIN_INPUT_LENGTH = 1;

/** ms: the search waits until the user stops typing for so long */
export const INPUT_TIMEOUT = 500;
